module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.1d8ac0bd.png";